import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import { formatViews } from "@/utils/format";

export default function FocusPicks() {
  const [lead, ...rest] = articles.slice(0, 4);

  return (
    <section aria-labelledby="focus-title" className="px-4 py-12 md:px-6 md:py-16">
      <div className="mb-7 flex flex-wrap items-end justify-between gap-3">
        <div>
          <p className="mb-2 flex items-center gap-2 text-xs font-medium tracking-[0.25em] text-primary-600">
            <span className="h-px w-6 bg-primary-400" />
            EDITOR PICK
          </p>
          <h2 id="focus-title" className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            编辑精选
          </h2>
        </div>
        <Link
          to="/news"
          className="inline-flex items-center gap-1 whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600"
        >
          浏览全部瓜料
          <i className="ri-arrow-right-line" aria-hidden="true" />
        </Link>
      </div>

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-5">
        <article className="group lg:col-span-3">
          <Link to={`/article/${lead.id}`} className="block overflow-hidden rounded-lg border border-background-200 bg-background-50">
            <div className="relative h-64 w-full overflow-hidden bg-background-200 md:h-80">
              <img
                src={lead.cover}
                alt={`${lead.title} - ${lead.categoryName}配图`}
                title={`${lead.title} - 诱惑吃瓜`}
                className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/25 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-4 md:p-6">
                <span className="rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
                  {lead.categoryName}
                </span>
                <h3 className="mt-3 text-lg font-bold leading-snug text-background-50 md:text-2xl">
                  {lead.title}
                </h3>
                <p className="mt-2 line-clamp-2 text-sm text-background-200/90">{lead.excerpt}</p>
                <p className="mt-3 flex items-center gap-4 text-xs text-background-300/80">
                  <span className="flex items-center gap-1">
                    <i className="ri-user-3-line" aria-hidden="true" />
                    {lead.author}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line" aria-hidden="true" />
                    {formatViews(lead.views)}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-chat-3-line" aria-hidden="true" />
                    {lead.comments}
                  </span>
                </p>
              </div>
            </div>
          </Link>
        </article>

        <div className="flex flex-col gap-4 lg:col-span-2">
          {rest.map((article) => (
            <article
              key={article.id}
              className="group flex flex-1 gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300"
            >
              <Link to={`/article/${article.id}`} className="flex w-full gap-4">
                <div className="h-24 w-24 shrink-0 overflow-hidden rounded-md bg-background-200 sm:h-28 sm:w-32">
                  <img
                    src={article.cover}
                    alt={`${article.title} - ${article.categoryName}配图`}
                    title={`${article.title} - 诱惑吃瓜`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="flex min-w-0 flex-col justify-between py-1">
                  <div>
                    <span className="text-xs text-secondary-700">{article.categoryName}</span>
                    <h3 className="mt-1 line-clamp-2 text-sm font-medium leading-snug text-foreground-900 transition-colors group-hover:text-primary-600">
                      {article.title}
                    </h3>
                  </div>
                  <p className="mt-2 flex items-center gap-3 text-xs text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line" aria-hidden="true" />
                      {formatViews(article.views)}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-chat-3-line" aria-hidden="true" />
                      {article.comments}
                    </span>
                  </p>
                </div>
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}